<template>
<!-- Top banner  -->
<header class="bd-main">
  <div class="container">
    <div class="columns mt-3">
      <div class="column is-2">
        <div class="navbar-brand">
            <a class="navbar-item" href="./">
                <img
                    src="images/history-logo.png"
                    alt="Histoy of HIV/ AIDS in Uganda"
                    class="brand"
                    data-src="images/history-logo.png"
                    data-src-retina="images/history-logo.png"
                    id="logo"
                />
            </a>
          </div>
      </div>
      <div class="column is-8 nav-container">
          <nav class="navbar is-transparent" role="navigation" aria-label="main navigation">
            <div @click="mobileMenuActive = !mobileMenuActive" 
             v-bind:class="{ 'is-active': mobileMenuActive }"
             id="navbarExampleTransparentExample" class="navbar-menu" >

                <div class="navbar-start">
                    <router-link class="navbar-item" :to="{ name: 'Timeline'}" exact>Timeline</router-link>
                    <router-link class="navbar-item" :to="{ name: 'Chapters'}" exact>History</router-link>
                    <router-link class="navbar-item" :to="{ name: 'Icons'}" exact>Icons</router-link>
                    <router-link class="navbar-item" :to="{ name: 'About'}" exact>About the Project</router-link>
                    <router-link class="navbar-item" :to="{ name: 'Acknowledgements'}" exact>Acknowledgements</router-link> 
                    <router-link class="navbar-item" :to="{ name: 'Quiz'}" exact>Quiz</router-link>
                    <router-link class="navbar-item only-mobile" :to="{ name: 'Contact'}" exact>Share your Story</router-link>
                </div>
            </div>
            <div @click="mobileMenuActive = !mobileMenuActive"
             class="navbar-burger" data-target="navbarExampleTransparentExample"
             v-bind:class="{ 'is-active': mobileMenuActive }" >

                <span></span>
                <span></span>
                <span></span>
              </div>
          </nav>
      </div>
      <div class="column is-2 mt-4 contact-wrapper off-mobile">
          <router-link class="navbar-item navbar-contact" :to="{ name: 'Contact'}" exact>Share your Story</router-link>
      </div>
    </div>
  </div>
</header>
</template>

<script>
    // import auth from '@/utils/AuthService'
    import sharedMethodsMixin from '@/mixins/sharedMethodsMixin'
    export default {
        name: "TopBar",
        mixins: [sharedMethodsMixin],
        components: {
            // VueCtkDateTimePicker,
        },
        data() {
            return {
                menu3: false,
                mobileMenuActive: false,
                logo: 'images/history-logo.png'
            }
        },
        mounted() {
        },
        updated(){
        },
        computed: {

        },
        watch: {

        },
        methods: {

        }
    }
</script>

<style>
</style>
